
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorHelp as ObiCursorHelpElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-help.js';
 
 
 

 
 export const ObiCursorHelp = createComponent({
   react: React,
   tagName: 'obi-cursor-help',
   elementClass: ObiCursorHelpElement,
   events: {
     
   }
  });
 
 